import { render } from "./Footer.vue?vue&type=template&id=678c4d07&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=678c4d07&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-678c4d07"
/* custom blocks */
import block0 from "./Footer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script